import { render, staticRenderFns } from "./ProductBreakdownStickyBar.vue?vue&type=template&id=d7135386&scoped=true&"
import script from "./ProductBreakdownStickyBar.vue?vue&type=script&lang=js&"
export * from "./ProductBreakdownStickyBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductBreakdownStickyBar.vue?vue&type=style&index=0&id=d7135386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7135386",
  null
  
)

export default component.exports